import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "hosting-guidelines"
    }}>{`Hosting guidelines`}</h1>
    <p>{`Guidelines for hosting a Design Systems Coalition NYC meetup`}</p>
    <h2 {...{
      "id": "about-us"
    }}>{`About us`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://www.meetup.com/NYC-Design-Systems-Coalition/"
      }}>{`Design Systems Coalition`}</a>{` is a niche meetup for people enthusiastic about design systems. This includes professionals, freelancers, designers and developers, brand designers, managers and directors, product managers, and anyone else interested in learning more or sharing their own experiences with building design systems.`}</p>
    <p>{`The NYC meetup is organized by `}<a parentName="p" {...{
        "href": "https://twitter.com/broccolini"
      }}>{`Diana Mounter`}</a>{`, Design Systems Manager at `}<a parentName="p" {...{
        "href": "https://github.com/"
      }}>{`GitHub`}</a>{`, `}<a parentName="p" {...{
        "href": "https://twitter.com/tomtaki"
      }}>{`Tom Takigayama`}</a>{`, Design Lead at `}<a parentName="p" {...{
        "href": "%5Bhttps://justworks.com%5D(https://justworks.com/)"
      }}>{`Justworks`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://twitter.com/jxnblk"
      }}>{`Brent Jackson`}</a>{`, Principle UX developer at `}<a parentName="p" {...{
        "href": "https://www.priceline.com/"
      }}>{`Priceline.com`}</a>{`. The meetup first formed in San Francisco and has chapters popping up in cities around the globe. It was born out of the `}<a parentName="p" {...{
        "href": "http://designsystems.herokuapp.com/"
      }}>{`Design Systems slack`}</a>{` community started by `}<a parentName="p" {...{
        "href": "https://twitter.com/jina"
      }}>{`Jina Anne`}</a>{`. Jina is a design systems advocate, former design lead on the `}<a parentName="p" {...{
        "href": "https://www.lightningdesignsystem.com/"
      }}>{`Lightning Design System`}</a>{`, and organizer of `}<a parentName="p" {...{
        "href": "http://clarityconf.com/"
      }}>{`Clarity`}</a>{`.`}</p>
    <h2 {...{
      "id": "event-format"
    }}>{`Event format`}</h2>
    <p>{`Each meetup features 3 speakers giving 10 minute lightning talks on the same topic area. After the talks have finished we kick off a panel-style Q&A session with curated questions, and then open questions to the floor. Our goal with the lightning talks and Q&A is to stimulate discussion, keeping plenty of time for networking and meeting other design systems enthusiasts. We focus each meetup on one topic area so that it's easier for speakers to create a short and focussed talk, and to ensure that over time, we cover the many areas that design systems work involves.`}</p>
    <h2 {...{
      "id": "venue-logistics"
    }}>{`Venue logistics`}</h2>
    <ul>
      <li parentName="ul">{`The venue should be able to accommodate between 60—100 people. Free meetups usually attract a 50% attendance rate, therefore we offer more spots on Meetup than we expect to attend. We'll work with you to ensure the numbers of attendees works for your venue capacity.`}</li>
      <li parentName="ul">{`AV equipement will be needed for projecting presenter slides.`}</li>
      <li parentName="ul">{`Not required, but if you are able to record the talks so that they can be shared online after the event that would be appreciated. Please let us know before hand if you are able to do this so we can notify presenters and attendees that talks will be recorded.`}</li>
      <li parentName="ul">{`A primary goal of Design Systems Coalition NYC is to be inclusive to the largest number of members, this means we require venues to be accessible, safe, and welcoming environments. Please read our `}<a parentName="li" {...{
          "href": "https://github.com/design-systems-coalition-NYC/meetup/blob/master/CODE_OF_CONDUCT.md"
        }}>{`Code of Conduct`}</a>{` for more information and reach out if you have any concerns about meeting these requirements.`}</li>
    </ul>
    <h2 {...{
      "id": "food-and-drink"
    }}>{`Food and drink`}</h2>
    <ul>
      <li parentName="ul">{`Hosts are expected to provide food and drinks for attendees since the event will be in the evening. Snacks should include vegan and gluten-free options, and if providing alcohol, non-alcoholic options should also be available. In the past hosts have provided foos such as charcuterrie style platters, chips and dips, cheeses & crackers, cookies, and pizza. Most hosts provide wine, beer, and a soda option, as well as water. We don't expect you to provide enough to replace an evening meal, just enough to tide folks over if they haven't eaten before they get to the venue.`}</li>
    </ul>
    <h2 {...{
      "id": "time-and-length"
    }}>{`Time and length`}</h2>
    <ul>
      <li parentName="ul">{`We'd like meetups to begin at 6.30, with talks beginning around 7, and the event ending around 9pm. We can be bit flexible on this though so please let us know if you have constraints around timing.`}</li>
      <li parentName="ul">{`We'd like organizers to be able to have access to the venue about 30 minutes before hand to help set up and make sure everything runs smoothly.`}</li>
    </ul>
    <h2 {...{
      "id": "venue-access-and-registration"
    }}>{`Venue access and registration`}</h2>
    <ul>
      <li parentName="ul">{`Tickets: the event is not ticketed but we will have an rsvp list which we will check on the door. We won't turn un-registered people away unless space is limited or the venue has other access restrictions. Usually there will be a number of no-shows that balance out occasional extras that turn up. We will take the name and email of un-registered attendees.`}</li>
      <li parentName="ul">{`Registration: if the venue requires a security check with ID before entering the event, please let us know so we can notify attendees. Organizers will need a small table near the entry to the event room for checking off RSVP's as people arrive.`}</li>
      <li parentName="ul">{`Building access: a primary goal of our meetup is to be inclusive to the largest number of members, this means we require venues to be accessible, safe, and welcoming environments.`}</li>
    </ul>
    <h2 {...{
      "id": "host"
    }}>{`Host`}</h2>
    <p>{`We would love someone from the hosting company to present on their design system, or a related topic. Each event will be focussed around a niche topic and we'll work with you to find a topic that works for you and is someone the design systems community is interested in.`}</p>
    <p>{`As part of hosting, we'd like to offer the following:`}</p>
    <ul>
      <li parentName="ul">{`Logos on event materials (the meetup page, slides loop during event, youtube video if the event is recorded)`}</li>
      <li parentName="ul">{`If you have jobs advertized that you'd like to share at the meetup we'll add the details to the slides loop, and you can give a shoutout at the event, we'll post on our `}<a parentName="li" {...{
          "href": "https://twitter.com/nyc_dsc"
        }}>{`twitter`}</a>{` too if you like.`}</li>
      <li parentName="ul">{`If there's something else you'd like to do that would make it worthwhile you hosting please let us know and we can discuss ideas.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      